module.exports = __webpack_public_path__ + "static/media/logo-dark-small.a0803569.png";